import React from 'react';
import { 
  CreditCard, 
  Globe, 
  Building2, 
  Shield,
  Bitcoin
} from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const PaymentMethodsSection = ({ transparent = false }) => {
  const { t } = useLanguage();
  return (
    <section className={`py-16 relative overflow-hidden ${transparent ? 'bg-transparent' : 'bg-slate-50'}`}>
      {/* Верхняя разделительная линия */}
      {!transparent && <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>}
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-sm text-gray-500 mb-8 max-w-3xl mx-auto">
            {t('payment.subtitle')}
          </p>
          
          <div className="flex justify-center items-center gap-8 flex-wrap">
            <div className="flex items-center gap-2 group">
              <div className="p-2 bg-gray-50 rounded-lg group-hover:bg-blue-50 transition-all duration-300 border border-gray-200">
                <Bitcoin className="w-6 h-6 text-blue-600" />
              </div>
              <span className="text-base font-medium text-gray-700">{t('payment.crypto')}</span>
            </div>
            <div className="flex items-center gap-2 group">
              <div className="p-2 bg-gray-50 rounded-lg group-hover:bg-blue-50 transition-all duration-300 border border-gray-200">
                <CreditCard className="w-6 h-6 text-blue-600" />
              </div>
              <span className="text-base font-medium text-gray-700">{t('payment.card')}</span>
            </div>
            <div className="flex items-center gap-2 group">
              <div className="p-2 bg-gray-50 rounded-lg group-hover:bg-blue-50 transition-all duration-300 border border-gray-200">
                <Building2 className="w-6 h-6 text-blue-600" />
              </div>
              <span className="text-base font-medium text-gray-700">{t('payment.bank')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};